<mat-spinner *ngIf="!initialized" [diameter]="100" class="page-loading"></mat-spinner>
